import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { CommonModelService } from '../../../../padu-reporting/capability/common-model.service';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ENTER } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-edit-ucmg',
  standalone: false,
  templateUrl: './edit-ucmg.component.html',
  styleUrl: './edit-ucmg.component.css'
})
export class EditUcmgComponent {
  @Input() currentTable: any;
  @Input() editUcmgData;
  @Input() isEditUcmg: any;
  @Output() editDataRefresh: EventEmitter<any> = new EventEmitter();
  remainingAcap: number = 0;
  editLoader: boolean = false;
  optumTechLabour :any;
  leaderOTAllocation: any;
  advisoryService: any;
  bussinessLabour: any;
  hardwareSoftware: any;
  otherChargebacks: any;
  professionalFees: any;
  numberFormatters = {};
  ucmgYear: any;
  comments: string;
  snapshotOriginalValues: any;
  @Input() yearList: any = [];
  allowNegative: boolean;
  @ViewChild('inputAddPortfolioManager') inputAddPortfolioManager: any;
  @ViewChild('inputAddUCMGOwner') inputAddUCMGOwner: any;
  @Input() editUCMGUserRole: any;
  @Input() segData: any;

  constructor(
    public maintenanceService: MaintenanceService,
    private toaster: ToastrService,
    private capabilityService: CommonModelService) {
  }

  ngOnInit() {
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });
  }

  ngOnChanges() {
    this.editUcmgData = JSON.parse(JSON.stringify(this.editUcmgData));

    if (this.editUcmgData && this.isEditUcmg) {
      this.allowNegative = (this.editUcmgData?.ACAP) < 0 ? true : false;
      this.assignValues();
      this.updateAvailableAcap();
    }

    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });
  }

  assignValues() {
    //reset owners
    this.AddOwner.Portfolio_Manager = [];
    this.AddOwner.UCMG_Owner = [];
    //to later see if any changes happend
    this.snapshotOriginalValues = {
      optumTechLabour: this.editUcmgData?.Optum_Tech_Labour,
      leaderOTAllocation: this.editUcmgData?.Leader_OT_Allocation,
      advisoryService: this.editUcmgData?.Advisory_Service,
      bussinessLabour: this.editUcmgData?.Bussiness_Labour,
      hardwareSoftware: this.editUcmgData?.Hardware_Software,
      otherChargebacks: this.editUcmgData?.Other_Chargebacks,
      professionalFees: this.editUcmgData?.Professional_Fees,
      comments: this.editUcmgData?.comments,
      Portfolio_Manager_Name: this.editUcmgData?.Portfolio_Manager_Name ? this.editUcmgData?.Portfolio_Manager_Name : '',
      Portfolio_Manager_MSID: this.editUcmgData?.Portfolio_Manager_MSID ? this.editUcmgData?.Portfolio_Manager_MSID : '',
      UCMG_Owner_MSID: this.editUcmgData?.UCMG_Owner_MSID ? this.editUcmgData?.UCMG_Owner_MSID : '',
      UCMG_Owner_Name: this.editUcmgData?.UCMG_Owner_Name ? this.editUcmgData?.UCMG_Owner_Name : ''
    }
    this.optumTechLabour = this.convertToDollarFormat((this.editUcmgData?.Optum_Tech_Labour));
    this.leaderOTAllocation = this.convertToDollarFormat((this.editUcmgData?.Leader_OT_Allocation));
    this.advisoryService = this.convertToDollarFormat((this.editUcmgData?.Advisory_Service));
    this.bussinessLabour = this.convertToDollarFormat((this.editUcmgData?.Bussiness_Labour));
    this.hardwareSoftware = this.convertToDollarFormat((this.editUcmgData?.Hardware_Software));
    this.otherChargebacks = this.convertToDollarFormat((this.editUcmgData?.Other_Chargebacks));
    this.professionalFees = this.convertToDollarFormat((this.editUcmgData?.Professional_Fees));
    this.comments = String(this.editUcmgData?.comments ? this.editUcmgData?.comments : "");
    if(this.editUcmgData?.Portfolio_Manager_Name){
      this.AddOwner.Portfolio_Manager.push({
        givenName: '',
        sn: '',
        mail: '',
        displayName: this.editUcmgData?.Portfolio_Manager_Name ?? '',
        employeeID: '',
        msid: this.editUcmgData?.Portfolio_Manager_MSID ?? '',
        middleName: ''
      });
    } else {
      this.AddOwner.Portfolio_Manager = [];
    }
    if(this.editUcmgData?.UCMG_Owner_Name){
      this.AddOwner.UCMG_Owner.push({
        givenName: '',
        sn: '',
        mail:'',
        displayName: this.editUcmgData?.UCMG_Owner_Name ?? '',
        employeeID: '',
        msid: this.editUcmgData?.UCMG_Owner_MSID ?? '',
        middleName: ''
      });
    } else {
      this.AddOwner.UCMG_Owner = [];
    }
  }

  applyEdit() {
    const payload={
      "optumTechLabour": this.normalizeValue(this.convertCommaSeparatedToNormal(this.optumTechLabour)),
      "leaderOTAllocation": this.normalizeValue(this.convertCommaSeparatedToNormal(this.leaderOTAllocation)),
      "advisoryService": this.normalizeValue(this.convertCommaSeparatedToNormal(this.advisoryService)),
      "bussinessLabour": this.normalizeValue(this.convertCommaSeparatedToNormal(this.bussinessLabour)),
      "hardware_software": this.normalizeValue(this.convertCommaSeparatedToNormal(this.hardwareSoftware)),
      "other_chargebacks": this.normalizeValue(this.convertCommaSeparatedToNormal(this.otherChargebacks)),
      "professional_fees": this.normalizeValue(this.convertCommaSeparatedToNormal(this.professionalFees)),
      "fiscalYear": this.editUcmgData.fiscalYear.toString(),
      "investmentStatus": this.editUcmgData.investmentStatus.toUpperCase(),
      "comments": this.comments ? this.comments : null,
      "Funding_SegmentID": this.editUcmgData.Funding_SegmentID,
      Portfolio_Manager: this.AddOwner.Portfolio_Manager,
      Ucmg_Owner: this.AddOwner.UCMG_Owner
    }
    this.editLoader = true;
    this.maintenanceService.editUcmg(payload, this.editUcmgData?.UCMG_ID).subscribe({
      next: data => {
        if (data) {
          this.toaster.success("Successfully updated", '', { timeOut: 10000, positionClass: 'toast-top-center' });
          this.editDataRefresh.emit(true);
          this.editLoader = false;
        }
      },
      error: async error => {
        this.editLoader = false;
        const errorMessage = error?.error?.message || 'An unexpected error occurred';
        this.toaster.error(errorMessage, '', { timeOut: 10000, positionClass: 'toast-top-center' });

        if (error?.error?.status !== 400 && error?.error?.errors) {
          this.toaster.error(error.error.errors, '', { timeOut: 10000, positionClass: 'toast-top-center' });
        }
      }
    });
  }

  normalizeValue = (value: any) => {
    if (value == null || value === '') {
      return 0; // Treat null, undefined, and empty strings as 0
    }
    return Math.round(Number(value)); // Ensure numeric values are rounded
  };

  disableEditUcmg() {

    //check if no changes
    const snapshot = this.snapshotOriginalValues;
    const current = {
      optumTechLabour: this.normalizeValue(this.convertCommaSeparatedToNormal(this.optumTechLabour)),
      leaderOTAllocation: this.normalizeValue(this.convertCommaSeparatedToNormal(this.leaderOTAllocation)),
      advisoryService: this.normalizeValue(this.convertCommaSeparatedToNormal(this.advisoryService)),
      bussinessLabour: this.normalizeValue(this.convertCommaSeparatedToNormal(this.bussinessLabour)),
      hardwareSoftware: this.normalizeValue(this.convertCommaSeparatedToNormal(this.hardwareSoftware)),
      otherChargebacks: this.normalizeValue(this.convertCommaSeparatedToNormal(this.otherChargebacks)),
      professionalFees: this.normalizeValue(this.convertCommaSeparatedToNormal(this.professionalFees)),
      comments: this.comments || '', // Normalize comments as strings
      Portfolio_Manager_Name: this.AddOwner.Portfolio_Manager.length > 0 ? this.AddOwner.Portfolio_Manager[0].displayName : '',
      Portfolio_Manager_MSID: this.AddOwner.Portfolio_Manager.length > 0 ? this.AddOwner.Portfolio_Manager[0].msid : '',
      UCMG_Owner_MSID: this.AddOwner.UCMG_Owner.length > 0 ? this.AddOwner.UCMG_Owner[0].msid : '',
      UCMG_Owner_Name: this.AddOwner.UCMG_Owner.length > 0 ? this.AddOwner.UCMG_Owner[0].displayName : ''
    };

    if (
      this.normalizeValue(snapshot.optumTechLabour) === current.optumTechLabour &&
      this.normalizeValue(snapshot.leaderOTAllocation) === current.leaderOTAllocation &&
      this.normalizeValue(snapshot.advisoryService) === current.advisoryService &&
      this.normalizeValue(snapshot.bussinessLabour) === current.bussinessLabour &&
      this.normalizeValue(snapshot.hardwareSoftware) === current.hardwareSoftware &&
      this.normalizeValue(snapshot.otherChargebacks) === current.otherChargebacks &&
      this.normalizeValue(snapshot.professionalFees) === current.professionalFees &&
      snapshot.Portfolio_Manager_Name === current.Portfolio_Manager_Name &&
      snapshot.Portfolio_Manager_MSID === current.Portfolio_Manager_MSID &&
      snapshot.UCMG_Owner_MSID === current.UCMG_Owner_MSID &&
      snapshot.UCMG_Owner_Name === current.UCMG_Owner_Name &&
      (snapshot.comments || '') === current.comments
    ) {
      return true;
    }
  }
  updateAvailableAcap(){
    this.remainingAcap = 0;
    const sum = this.normalizeValue(this.convertCommaSeparatedToNormal(this.optumTechLabour)) +this.normalizeValue(this.convertCommaSeparatedToNormal(this.advisoryService)) + this.normalizeValue(this.convertCommaSeparatedToNormal(this.bussinessLabour)) + this.normalizeValue(this.convertCommaSeparatedToNormal(this.hardwareSoftware)) + this.normalizeValue(this.convertCommaSeparatedToNormal(this.otherChargebacks))
    + this.normalizeValue(this.convertCommaSeparatedToNormal(this.professionalFees)) + this.normalizeValue(this.convertCommaSeparatedToNormal(this.leaderOTAllocation));
    this.remainingAcap = this.normalizeValue(this.convertCommaSeparatedToNormal(this.editUcmgData?.ACAP))-sum;
  }

  convertCommaSeparatedToNormal(value) {
    if(value == null ||value === '' || value === undefined|| value === '.'||value === '-'){
      return '';
    }
    else if (typeof (value) != 'number')
      return parseFloat(value.replace(/,/g, ''));
    else
      return value;
  }

   convertToDollarFormat(value) {
    if(value == null ||value === '' || value === undefined){
      return '';
    }
    value = value.toFixed();
    const rawValue = value.replace(/[^\d-]/g, '');
    const formatted = this.formatNumber(rawValue);
    return formatted;
  }

  private formatNumber(value: string): string {
    const number = Number(value) || '';
    return number.toLocaleString('en-US');
  }

  AddOwner = {
    'Portfolio_Manager': [],
    'UCMG_Owner': []
  };
  inputElement: any;
  disableEdit: boolean = true;
  userRole: any;
  LDAPusersPM: any = [];
  LDAPusersUCMG: any = [];
  private subject: Subject<string> = new Subject();
  destroy$: ReplaySubject<boolean> = new ReplaySubject(1);
  separatorKeysCodes: number[] = [ENTER];

  removePortfolioManagerAndUCMGOwner(user, role) {
    if (role === 'Portfolio_Manager') {
      const index = this.AddOwner.Portfolio_Manager.indexOf(user);
      if (index >= 0) {
        this.AddOwner.Portfolio_Manager.splice(index, 1);
      }
    }
    else {
      const index = this.AddOwner.UCMG_Owner.indexOf(user);
      if (index >= 0) {
        this.AddOwner.UCMG_Owner.splice(index, 1);
      }
    }
  }

  keyUpSearch(name, type) {
    const p: any = {}
    p['type'] = type;
    p['search'] = name.target.value;
    this.inputElement = name;
    if (name.target.value) {
      this.subject.next(p);
    }
    else if (!name.target.value && type === 'Portfolio_Manager') {
      this.LDAPusersPM = [];
    }
    else if (!name.target.value && type === 'UCMG_Owner') {
      this.LDAPusersUCMG = [];
    }
  }

  focusOnInput(type) {
    if (type === 'inputAddPortfolioManager') {
      this.inputAddPortfolioManager.nativeElement.focus();
    }
    else if (type === 'inputAddUCMGOwner') {
      this.inputAddUCMGOwner.nativeElement.focus();
    }
  }

  AddOwnerRole(event, role) {
    if (event.option.value.givenName !== '') {
      if (role === 'Portfolio_Manager') {
        this.userRole = role;
        this.AddOwner.Portfolio_Manager.push({
          givenName: event.option.value.givenName,
          sn: event.option.value.sn,
          mail: event.option.value.mail,
          displayName: event.option.value.displayName,
          employeeID: event.option.value.employeeID,
          msid: event.option.value.msid,
          middleName: event.option.value.sn
        });
      }
      else if (role === 'UCMG_Owner') {
        this.userRole = role;
        this.AddOwner.UCMG_Owner.push({
          givenName: event.option.value.givenName,
          sn: event.option.value.sn,
          mail: event.option.value.mail,
          displayName: event.option.value.displayName,
          employeeID: event.option.value.employeeID,
          msid: event.option.value.msid,
          middleName: event.option.value.sn
        }
      );
      }
    }
    if (this.inputElement) {
      this.inputElement.target.value = '';
      if(role === 'Portfolio_Manager'){
        this.LDAPusersPM = []
      } else if (role === 'UCMG_Owner'){
        this.LDAPusersUCMG = []
      }
    }
  }

  checkExistUser(user, type, actionType) {
    let tempVar = [];
    if (actionType === 'Add') {
      if (type === 'Portfolio_Manager') {
        tempVar = this.AddOwner.Portfolio_Manager;
      }
      else {
        tempVar = this.AddOwner.UCMG_Owner;
      }
    }
    let tempBool = false
    tempVar.forEach(archi => {
      if (user.msid === archi.msid) {
        tempBool = true;
      }
    });
    return tempBool;
  }

  handleSearch(searchObj) {
    console.log("searchObj", searchObj);
    let type = searchObj['type'];
    const value = searchObj['search'];
    const column = searchObj['column'];
    if (value) {
      this.capabilityService.getLDAPUsers(value).subscribe(dataStream => {
        // Use the correct array based on type
        if (type === 'Portfolio_Manager') {
          this.LDAPusersPM = [];
          dataStream.forEach(element => {
            this.LDAPusersPM.push({
              givenName: element.givenName,
              sn: element.sn,
              mail: element.mail,
              displayName: element.displayName,
              employeeID: element.employeeID,
              msid: element.cn,
              middleName: element.middleName,
            });
          });
        } else if (type === 'UCMG_Owner') {
          this.LDAPusersUCMG = [];
          dataStream.forEach(element => {
            this.LDAPusersUCMG.push({
              givenName: element.givenName,
              sn: element.sn,
              mail: element.mail,
              displayName: element.displayName,
              employeeID: element.employeeID,
              msid: element.cn,
              middleName: element.middleName,
            });
          });
        }
      }, (error) => {
        console.error(error);
        const errorMessage = error?.error?.message ? error?.error?.message : 'Internal Server Error';
        this.toaster.error(errorMessage, '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      });
    } else {
      if (type === 'Portfolio_Manager') {
        this.LDAPusersPM = [];
      } else if (type === 'UCMG_Owner') {
        this.LDAPusersUCMG = [];
      }
      if (column) {
        column.options = [];
      }
    }
  }

  removeOwners(user, role) {
    if (role === 'Portfolio_Manager') {
      const index = this.AddOwner.Portfolio_Manager.indexOf(user);
      if (index >= 0) {
        this.AddOwner.Portfolio_Manager.splice(index, 1);
      }
    }
    else {
      const index = this.AddOwner.UCMG_Owner.indexOf(user);
      if (index >= 0) {
        this.AddOwner.UCMG_Owner.splice(index, 1);
      }
    }
  }


}
